import styled, { css } from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Wrapper = styled.div`
  p {
    font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
  }
  .button_wrapper {
    display: flex;
    justify-content: flex-end;
    @media (max-width: ${defaultBreakpoints.medium}) {
      justify-content: stretch;
    }
  }
  .actions {
    display: grid;
    grid-template-columns: 1fr 200px;
    @media (max-width: ${defaultBreakpoints.medium}) {
      grid-template-columns: 1fr;
    }
  }
  span {
    font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 15px;
    letter-spacing: 0em;
    text-align: left;
  }
`;
